import { Component, Input, ViewChild } from '@angular/core';
import { BaseForm } from '@forms/base.form';
import { OfferLetter } from '@app/models/offer-letters/offer-letter.model';
import { MergeFieldFormInputAttributes } from '@app/modules/offer-letter/functions/offer-letter-field-form-input-attributes';
import { MergeFieldFormInputTypes } from '@app/enums';
import { DeprecatedModalFormComponent } from '@app/components';
import { OfficeForm, PositionForm } from '@app/modules/forms/company/components';
import { DepartmentForm } from '@app/modules/forms/employees/components';
import { Office } from '@app/models/company/office.model';
import { Job } from '@app/models/company/job.model';
import { Department } from '@app/models/company/department.model';
import { AuthService } from '@app/services';
import { Model } from '@app/models/core/base.model';
import moment from 'moment';

@Component({
    selector: 'app-letter-details',
    templateUrl: './letter-details.form.html',
})
export class LetterDetailsForm extends BaseForm {
    @Input() offerLetter: OfferLetter;
    @Input() mergeFieldFormInputAttributes: MergeFieldFormInputAttributes[] = [];
    @Input() isLoading = false;

    @ViewChild('departmentModal', { static: false }) departmentModal: DeprecatedModalFormComponent;
    @ViewChild('positionModal', { static: false }) positionModal: DeprecatedModalFormComponent;
    @ViewChild('officeModal', { static: false }) officeModal: DeprecatedModalFormComponent;

    /**
     * Used to set a minimum for expiration date
     */
    today = moment(new Date()).format('YYYY-MM-DD');
    mergeFieldFormInputTypes = MergeFieldFormInputTypes;
    currentMergeFieldFormInputAttribute: MergeFieldFormInputAttributes;

    constructor(private auth: AuthService) {
        super();
    }

    showModal(mergeFieldFormInputAttribute: MergeFieldFormInputAttributes): void {
        this.currentMergeFieldFormInputAttribute = mergeFieldFormInputAttribute;

        switch (this.currentMergeFieldFormInputAttribute.attributeName) {
            case 'department': {
                this.departmentModal.show();
                break;
            }
            case 'position': {
                this.positionModal.show();
                break;
            }
            case 'location': {
                this.officeModal.show();
                break;
            }
        }
    }

    compareWith(originalValue: string | Model, selectedValue: string | Model): boolean {
        if (typeof originalValue === 'object') {
            return originalValue.is(selectedValue as Model);
        }

        return originalValue === selectedValue;
    }

    onCancel(): void {
        return;
    }

    async createAndSetOffice(form: OfficeForm): Promise<void> {
        this.isLoading = true;

        const office: Office = await form.office.param('company', this.auth.company.id).save();
        this.offerLetter.location = office;

        this.addAndSortNewDropdownOption(office);

        form.reset();
        this.isLoading = false;
    }

    async createAndSetPosition(form: PositionForm): Promise<void> {
        this.isLoading = true;

        const position: Job = await form.position.param('company', this.auth.company.id).save();
        this.offerLetter.position = position;

        this.addAndSortNewDropdownOption(position);

        form.reset();
        this.isLoading = false;
    }

    async createAndSetDepartment(form: DepartmentForm): Promise<void> {
        this.isLoading = true;

        const department: Department = await form.department.param('company', this.auth.company.id).save();
        this.offerLetter.department = department;

        this.addAndSortNewDropdownOption(department);

        form.reset();
        this.isLoading = false;
    }

    private addAndSortNewDropdownOption(newOption: Model): void {
        this.currentMergeFieldFormInputAttribute.dropDownOptions.options.push(newOption);
        this.currentMergeFieldFormInputAttribute.dropDownOptions.options.sort();
    }
}
